module.exports = __webpack_public_path__ + "hbomaxar-static/media/LiquidTrip_OpenLoop_00215.41bfdfd1.png";